import BaseModel from './base.model';

class PartReturnModel extends BaseModel {
  public partId: string;
  public amount: number;
  public backorder: boolean;
  public creationDate: string;
  public deliveryDate: string;
  public description: string;
  public invoiceNumber: string;
  public lineNumber: number;
  public manufacturerCode: string;
  public orderNumber: number;
  public price: number;
  public productNumber: string;
  public quantity: number;
  public shipmentMarking: string;
  public shippedFromLocation: string;
  public cancellationStatus: number;
}

export default PartReturnModel;
